export default {
      id: "common__ftp-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#common__ftp",
      toString: function () {
        return this.url;
      }
    }